const {
  getStates2,
  getStatesV2,
  AllMarkets,
  getStates,
  getRules,
  getLocales,
} = require('./lib');

module.exports = {
  getStates2,
  getStatesV2,
  AllMarkets,
  getStates,
  getRules,
  getLocales,
};
